export const clipboard = async (value?: string | ClipboardItem) => {
  if (typeof value === "string") {
    await navigator.clipboard.writeText(value);
  } else if (value instanceof ClipboardItem) {
    await navigator.clipboard.write([value]);
  }
};
